import React from 'react';

import Highlight from 'common/developers/docs/api/Highlight';

type Props = {
  method?: string;
  path: string;
  body: string;
};

const APIDocsCurl = ({ method = 'POST', body, path }: Props) => {
  return (
    <>
      <div className="text">Example Request</div>
      <Highlight lang="shell">{`$ curl ${path} -X ${method} ${body}`}</Highlight>
    </>
  );
};
export default APIDocsCurl;
